import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { FormattedMessage } from 'react-intl'
import { DragSource } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import * as detectIt from 'detect-it'
import cx from 'classnames'
import ContextMenu, { Item } from 'gnos-context-menu'
import { doubleClick } from 'gnos-utilities/event'
import _ from 'lodash'

import { DND_TYPE } from '../../dnd/constants'
import { LOCALE_PREFIX } from './constants'

import CloseButton from '../CloseButton'

import acl from '../../services/acl'
import hocConnect from './hocConnect'

import './style.scss'

const groupSource = {
    beginDrag: (props) => ({
        groupId: _.toString(props.group.get('id')),
        name: props.group.get('name'),
        count: props.group.get('members'),
    }),
}

function collect(connect) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
    }
}

@acl
@hocConnect
@doubleClick
@DragSource(DND_TYPE.GROUP, groupSource, collect)
export default class GroupEntity extends Component {
    static propTypes = {
        connectDragPreview: PropTypes.func.isRequired,
        connectDragSource: PropTypes.func.isRequired,
        deleteGroup: PropTypes.func.isRequired,
        group: IPropTypes.map.isRequired,
        hasRights: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        isClickOrDoubleClick: PropTypes.func.isRequired,
        openPortfolioById: PropTypes.func.isRequired,
        renderWraps: PropTypes.bool,
        toggleGroupStack: PropTypes.func.isRequired,
    }

    static defaultProps = {
        renderWraps: true,
    }

    componentDidMount() {
        const { connectDragPreview } = this.props

        connectDragPreview(getEmptyImage())
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.isActive !== nextProps.isActive) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.renderWraps !== nextProps.renderWraps) return true
        if (!this.props.group.equals(nextProps.group)) return true

        return false
    }

    onGroupClick = (_e) => {
        const { id, group, openPortfolioById, toggleGroupStack, isClickOrDoubleClick } = this.props

        isClickOrDoubleClick(
            _e,
            () => {
                toggleGroupStack(id, group.get('name'))
            },
            () => {
                openPortfolioById(id)
            }
        )
    }

    onContextMenuAddPortfolioClick = () => {
        const { id, openPortfolioById } = this.props

        openPortfolioById(id)
    }

    onDeleteGroupClick = () => {
        const { id, deleteGroup } = this.props

        deleteGroup(id)
    }

    renderContextMenu = (content) => {
        const { id, hasRights } = this.props

        const items = [
            hasRights('portfolio') && (
                <Item
                    key={'portfolio'}
                    type={'portfolio'}
                    text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.generatePortfolio`} />}
                    onItemClick={this.onContextMenuAddPortfolioClick}
                />
            ),
            <Item
                key={'delete'}
                type={'delete'}
                text={<FormattedMessage id={`${LOCALE_PREFIX}.contextMenu.delete`} />}
                onItemClick={this.onDeleteGroupClick}
            />,
        ]

        return (
            <ContextMenu id={`contextMenu_${id}`} content={items}>
                <div className={'wrap-group-entity-context-menu'}>{content}</div>
            </ContextMenu>
        )
    }

    render() {
        const { connectDragSource, group, renderWraps, isActive } = this.props

        let content = (
            <div className={cx('group-entity-wrap', isActive && 'is-active')} onClick={this.onGroupClick}>
                <div className={cx('icon', isActive && 'is-active')} />
                <div className={'texts'}>
                    <div className={'name'}>{group.get('name')}</div>
                    <div className={'count'}>
                        <FormattedMessage
                            id={'components.GroupEntity.members'}
                            values={{ memberCount: group.get('members') }}
                        />
                    </div>
                    <div className={'icons-wrap'}>
                        {group.get('flags', Map()).get('monitoring', false) && (
                            <div className={cx('small-icon', 'monitoring')} />
                        )}
                        {group.get('flags', Map()).get('sendEmails', false) && (
                            <div className={cx('small-icon', 'notifications')} />
                        )}
                    </div>
                </div>
                <div className={'close-area'}>
                    <CloseButton onClick={this.onDeleteGroupClick} pad={2} size={14} />
                </div>
            </div>
        )

        // wrap content to DnD Source component
        if (detectIt.deviceType !== 'touchOnly') content = connectDragSource(content)

        // wrap content to ContextMenu component
        if (renderWraps) content = this.renderContextMenu(content)

        return content
    }
}
